export const DRAFT = "DRAFT"
export const PUBLISHED = "PUBLISHED"
export const ARCHIVED = "ARCHIVED"
export const COMING_SOON = "COMING_SOON"
